<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ ModalTitle }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClick()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-employee-view-edit [Date]="Date" [employee]="employee" [attendanceList]="attendanceList"
                    [clockifyList]="clockifyList" *ngIf="activateModal">
                </app-employee-view-edit>
            </div>
        </div>
    </div>
</div>
<!-- The Table Legend and Balance view -->
<div class="row">
    <div class="col-md-12">
        <div class="container-fluid ">
            <div class="row mt--2">
                <div class="col-md-3">
                    <div class="card shadow" style="border-radius: 0.5rem">
                        <div class="card-body">
                            <div class="card-header">
                                <div class="card-title">Table Legend</div>
                                <div class="card-category">Hover over icons in the table for more info</div>
                            </div>
                            <div class="row py-3">
                                <div class='ml-3'>
                                    <div class=''>
                                        <ul class='list-group list-group-flush text-muted' style="font-size: 12px">
                                            <li class="list-group-item p-1">
                                                <i style="color:green" class="fas fa-check mt-1"></i>
                                                All is fine.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:rgb(255, 170, 0)" class="fas fa-clock mt-1"></i>
                                                Employee either worked a half day or a quarter day.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:rgb(189, 0, 0)"
                                                    class="fas fa-exclamation px-1 mt-1"></i>
                                                Non-Technical employee came to office on a weekend.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:rgb(189, 0, 0); margin-right: 2px;"
                                                    class="fas fa-times fa-lg mt-1"></i>
                                                Unmarked employee leave.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:green; margin-right: 1px;"
                                                    class="fas fa-check-circle mt-1"></i>
                                                A leave that has been marked.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:rgb(189, 0, 0)"
                                                    class="fas fa-exclamation-triangle mt-1"></i>
                                                Data missing or discrepancy in data.
                                            </li>
                                            <li class="list-group-item p-1">
                                                <i style="color:black; margin-right: 2px;"
                                                    class="fas fa-times fa-lg mt-1"></i>
                                                Public Holiday.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="card shadow" style="border-radius: 0.5rem">
                        <div class="card-body">
                            <div class="card-header">
                                <div class="card-title">Leave Balances</div>
                                <div class="card-category">Your current and expected balances based on the amount of
                                    absences you've taken to date</div>
                            </div>
                            <div class="d-flex flex-wrap justify-content-around pb-2 pt-4"
                                *ngIf="employee !== undefined">
                                <!-- <div class="px-2 pb-2 pb-md-0 text-center">
                                    <div id="circles-1"></div>
                                    <h6 class="fw-bold mt-3 mb-0">New Users</h6>
                                </div>
                                <div class="px-2 pb-2 pb-md-0 text-center">
                                    <div id="circles-2"></div>
                                    <h6 class="fw-bold mt-3 mb-0">Sales</h6>
                                </div>
                                <div class="px-2 pb-2 pb-md-0 text-center">
                                    <div id="circles-3"></div>
                                    <h6 class="fw-bold mt-3 mb-0">Subscribers</h6>
                                </div> -->
                                <div class="px-2 pb-2 pb-md-0 text-center mt-auto">
                                    <p class="card-category mt-3">Current Casual Balance</p>
                                    <circle-progress [percent]="(employee.CasualLeaveBalance/20)*100"
                                        [title]="employee.CasualLeaveBalance">
                                    </circle-progress>
                                </div>
                                <div class="px-2 pb-2 pb-md-0 text-center mt-auto">
                                    <p class="card-category mt-3">Current Annual Balance</p>
                                    <circle-progress [percent]="(employee.AnnualLeaveBalance/8)*100"
                                        [title]="employee.AnnualLeaveBalance">
                                    </circle-progress>
                                </div>
                                <div class="px-2 pb-2 pb-md-0 text-center">
                                    <p class="card-category mt-3">Expected Casual Balance <br> at end of month</p>
                                    <circle-progress [percent]="(employee.CasualLeaveBalance/20)*100"
                                        [title]="employee.CasualLeaveBalance">
                                    </circle-progress>
                                </div>
                                <div abled class="px-2 pb-2 pb-md-0 text-center">
                                    <p class="card-category mt-3">Expected Annual Balance <br> at end of month</p>
                                    <circle-progress [percent]="(employee.AnnualLeaveBalance/8)*100"
                                        [title]="employee.AnnualLeaveBalance">
                                    </circle-progress>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- The main attendance table -->
<div class="col-md-12">
    <div class="card" style="border-radius: 0.5rem">
        <div class="card-body">
            <div class="container-fluid mb-0 ">
                <p *ngIf="dateLastImported && dateLastImportedFor"><small>Admin last imported data on
                        <b>{{dateLastImported | date: 'mediumDate'}}</b> for
                        <b>{{dateLastImportedFor | date: 'MMMM YYYY'}}</b></small></p>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="container-fluid my-4">
                        <div class="d-flex flex-wrap justify-content-between">
                            <h1 class="mb-0 d-flex">
                                <div class="mr-1" style="align-content: center; margin-top: 0.75%;">
                                    Attendance Summary for the year
                                </div>
                                <div class="dropdown">
                                    <h1 class="btn-outline-dark btn-sm dropdown-toggle" role="button" id="dropdownYear"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{ year }}
                                    </h1>
                                    <div class="dropdown-menu" aria-labelledby="dropdownYear">
                                        <button *ngFor="let item2 of yearDropdown" class="dropdown-item" type="button"
                                            (click)="UpdateYear(item2)">
                                            {{ item2 }}
                                        </button>
                                    </div>
                                </div>
                            </h1>
                            <div>
                                <button (click)="ViewRequests()" type="button" class="mr-1 btn btn-outline-info">
                                    <i class="far fa-eye"></i>
                                    | View Requests
                                </button>
                                <button (click)="ViewReports()" type="button" class="btn btn-outline-info">
                                    <i class="far fa-eye"></i>
                                    | View Reports
                                </button>
                            </div>
                        </div>
                        <button (click)="Test()"></button>
                        <div class="w-100 scroll">
                            <table class="table table-striped table-sm table-hover mb-4">
                                <thead class="thead-dark">
                                    <tr>
                                        <th class="sticky-row first-row">Name</th>
                                        <th class="wid-10 text-center" style="padding: 0px !important;"
                                            *ngFor="let date of dayList">
                                            <div class="wid-10">{{ date }}</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let month of monthDropdown">
                                        <td style="padding: 10px !important;">
                                            {{ month.Text }}
                                        </td>
                                        <td *ngFor="let day of dayList">
                                            <!-- {{day}}
                                            {{month.Value}} -->
                                            <div [ngSwitch]="CheckStatus(day, month.Value)">
                                                <!-- tick -->
                                                <div *ngSwitchCase="1" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button style="background-color:transparent;" class="border-0">
                                                        <i style="color:green" class="fas fa-check"></i>
                                                        <!-- &#10004; -->
                                                    </button>
                                                </div>
                                                <!-- red cross -->
                                                <div *ngSwitchCase="2" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working day - You were absent">
                                                        <i style="color:rgb(189, 0, 0)" class="fas fa-times fa-lg"></i>
                                                        <!-- &#10060; -->
                                                    </button>
                                                </div>
                                                <!-- green tick for marked leave -->
                                                <div *ngSwitchCase="20" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working day - You were absent - Leave marked">
                                                        <i style="color:green" class="fas fa-check-circle fa-lg"></i>
                                                        <!-- &#10060; -->
                                                    </button>
                                                </div>
                                                <!-- grey cross | weekend -->
                                                <div *ngSwitchCase="3" class=" text-center">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" disabled>
                                                        &#10006;
                                                    </button>
                                                </div>
                                                <!-- black cross | holiday -->
                                                <div *ngSwitchCase="30" class=" text-center">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Holiday - {{GetHolidayName(day, month.Value)}}">
                                                        <i style="color:black" class="fas fa-times fa-lg"></i>
                                                    </button>
                                                </div>
                                                <!-- exclamation -->
                                                <div *ngSwitchCase="4" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Weekend - You worked extra hours">
                                                        <i style="color:rgb(189, 0, 0)"
                                                            class="fas fa-exclamation fa-md"></i>
                                                        <!-- &#10071; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="5" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="You worked an extra half day">
                                                        <i style="color:rgb(255, 196, 0)"
                                                            class="fas fa-clock fa-lg"></i> <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="6" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="You worked an extra half day">
                                                        <i style="color:rgb(255, 123, 0)"
                                                            class="fas fa-clock fa-lg"></i> <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="7" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - You worked half of the day">
                                                        <i style="color:rgb(255, 196, 0)"
                                                            class="fas fa-clock fa-lg"></i>
                                                        <!-- &#8987; -->
                                                    </button>
                                                </div>
                                                <!-- clock -->
                                                <div *ngSwitchCase="8" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - You worked half of the day">
                                                        <i style="color:rgb(255, 123, 0)"
                                                            class="fas fa-clock fa-lg"></i> </button>
                                                </div>
                                                <!-- warning -->
                                                <div *ngSwitchCase="0" class=" text-center"
                                                    (click)="Click(day, month.Value)" data-toggle="modal"
                                                    data-target="#exampleModalCenter" data-backdrop="static"
                                                    data-keyboard="false">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" data-toggle="tooltip" placement="top"
                                                        ngbTooltip="Working Day - You swiped card only once">
                                                        <i style="color:rgb(189, 0, 0)"
                                                            class="fas fa-exclamation-triangle fa-lg"></i>
                                                        <!-- &#9888; -->
                                                    </button>
                                                </div>
                                                <!-- dates ahead of current time -->
                                                <div *ngSwitchCase="100" class=" text-center">
                                                    <button type="button" style="background-color:transparent"
                                                        class="border-0" disabled>
                                                        <i style="color:rgb(197, 197, 197)"
                                                            class="fas fa-circle fa-xs"></i>
                                                        <!-- &#9888; -->
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>